/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { AdgangAccessControl } from './AdgangAccessControl';
import {
    AdgangAccessControlFromJSON,
    AdgangAccessControlFromJSONTyped,
    AdgangAccessControlToJSON,
    AdgangAccessControlToJSONTyped,
} from './AdgangAccessControl';
import type { ApplicationStatus } from './ApplicationStatus';
import {
    ApplicationStatusFromJSON,
    ApplicationStatusFromJSONTyped,
    ApplicationStatusToJSON,
    ApplicationStatusToJSONTyped,
} from './ApplicationStatus';
import type { ApplicationExternalApproverResponse } from './ApplicationExternalApproverResponse';
import {
    ApplicationExternalApproverResponseFromJSON,
    ApplicationExternalApproverResponseFromJSONTyped,
    ApplicationExternalApproverResponseToJSON,
    ApplicationExternalApproverResponseToJSONTyped,
} from './ApplicationExternalApproverResponse';
import type { ApplicationMigrationStatus } from './ApplicationMigrationStatus';
import {
    ApplicationMigrationStatusFromJSON,
    ApplicationMigrationStatusFromJSONTyped,
    ApplicationMigrationStatusToJSON,
    ApplicationMigrationStatusToJSONTyped,
} from './ApplicationMigrationStatus';
import type { ApplicationResponsiblePersonResponse } from './ApplicationResponsiblePersonResponse';
import {
    ApplicationResponsiblePersonResponseFromJSON,
    ApplicationResponsiblePersonResponseFromJSONTyped,
    ApplicationResponsiblePersonResponseToJSON,
    ApplicationResponsiblePersonResponseToJSONTyped,
} from './ApplicationResponsiblePersonResponse';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { ClientSecretResponse } from './ClientSecretResponse';
import {
    ClientSecretResponseFromJSON,
    ClientSecretResponseFromJSONTyped,
    ClientSecretResponseToJSON,
    ClientSecretResponseToJSONTyped,
} from './ClientSecretResponse';

/**
 * 
 * @export
 * @interface ApplicationResponse
 */
export interface ApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    clientId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationResponse
     */
    redirectUris?: Array<string> | null;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof ApplicationResponse
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    isSearchableInMinSide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    allowsExternalApprovers?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    canAppResponsiblesAppointExternalApprovers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    isIdPortenFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    isStafFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    requiresElevatedSecurityPolicy?: boolean;
    /**
     * 
     * @type {UserType}
     * @memberof ApplicationResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof ApplicationResponse
     */
    status?: ApplicationStatus;
    /**
     * 
     * @type {ApplicationMigrationStatus}
     * @memberof ApplicationResponse
     */
    migrationStatus?: ApplicationMigrationStatus;
    /**
     * 
     * @type {Array<ApplicationResponsiblePersonResponse>}
     * @memberof ApplicationResponse
     */
    responsiblePersons?: Array<ApplicationResponsiblePersonResponse> | null;
    /**
     * 
     * @type {Array<ApplicationExternalApproverResponse>}
     * @memberof ApplicationResponse
     */
    externalApprovers?: Array<ApplicationExternalApproverResponse> | null;
    /**
     * 
     * @type {Array<ClientSecretResponse>}
     * @memberof ApplicationResponse
     */
    passwordCredentials?: Array<ClientSecretResponse> | null;
    /**
     * 
     * @type {Array<AdgangAccessControl>}
     * @memberof ApplicationResponse
     */
    accessControls?: Array<AdgangAccessControl> | null;
}



/**
 * Check if a given object implements the ApplicationResponse interface.
 */
export function instanceOfApplicationResponse(value: object): value is ApplicationResponse {
    return true;
}

export function ApplicationResponseFromJSON(json: any): ApplicationResponse {
    return ApplicationResponseFromJSONTyped(json, false);
}

export function ApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'clientId': json['clientId'] === undefined ? undefined : json['clientId'] === null ? null : json['clientId'],
        'redirectUris': json['redirectUris'] === undefined ? undefined : json['redirectUris'] === null ? null : json['redirectUris'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'isSearchableInMinSide': json['isSearchableInMinSide'] == null ? undefined : json['isSearchableInMinSide'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'allowsExternalApprovers': json['allowsExternalApprovers'] === undefined ? undefined : json['allowsExternalApprovers'] === null ? null : json['allowsExternalApprovers'],
        'canAppResponsiblesAppointExternalApprovers': json['canAppResponsiblesAppointExternalApprovers'] == null ? undefined : json['canAppResponsiblesAppointExternalApprovers'],
        'isIdPortenFederationDisabled': json['isIdPortenFederationDisabled'] == null ? undefined : json['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': json['isStafFederationDisabled'] == null ? undefined : json['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': json['requiresElevatedSecurityPolicy'] == null ? undefined : json['requiresElevatedSecurityPolicy'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'status': json['status'] == null ? undefined : ApplicationStatusFromJSON(json['status']),
        'migrationStatus': json['migrationStatus'] == null ? undefined : ApplicationMigrationStatusFromJSON(json['migrationStatus']),
        'responsiblePersons': json['responsiblePersons'] === undefined ? undefined : json['responsiblePersons'] === null ? null : ((json['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonResponseFromJSON)),
        'externalApprovers': json['externalApprovers'] === undefined ? undefined : json['externalApprovers'] === null ? null : ((json['externalApprovers'] as Array<any>).map(ApplicationExternalApproverResponseFromJSON)),
        'passwordCredentials': json['passwordCredentials'] === undefined ? undefined : json['passwordCredentials'] === null ? null : ((json['passwordCredentials'] as Array<any>).map(ClientSecretResponseFromJSON)),
        'accessControls': json['accessControls'] === undefined ? undefined : json['accessControls'] === null ? null : ((json['accessControls'] as Array<any>).map(AdgangAccessControlFromJSON)),
    };
}

export function ApplicationResponseToJSON(json: any): ApplicationResponse {
    return ApplicationResponseToJSONTyped(json, false);
}

export function ApplicationResponseToJSONTyped(value?: ApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shortName': value['shortName'],
        'name': value['name'],
        'description': value['description'],
        'url': value['url'],
        'clientId': value['clientId'],
        'redirectUris': value['redirectUris'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'isSearchableInMinSide': value['isSearchableInMinSide'],
        'requiresMfa': value['requiresMfa'],
        'allowsExternalApprovers': value['allowsExternalApprovers'],
        'canAppResponsiblesAppointExternalApprovers': value['canAppResponsiblesAppointExternalApprovers'],
        'isIdPortenFederationDisabled': value['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': value['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': value['requiresElevatedSecurityPolicy'],
        'userType': UserTypeToJSON(value['userType']),
        'status': ApplicationStatusToJSON(value['status']),
        'migrationStatus': ApplicationMigrationStatusToJSON(value['migrationStatus']),
        'responsiblePersons': value['responsiblePersons'] == null ? undefined : ((value['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonResponseToJSON)),
        'externalApprovers': value['externalApprovers'] == null ? undefined : ((value['externalApprovers'] as Array<any>).map(ApplicationExternalApproverResponseToJSON)),
        'passwordCredentials': value['passwordCredentials'] == null ? undefined : ((value['passwordCredentials'] as Array<any>).map(ClientSecretResponseToJSON)),
        'accessControls': value['accessControls'] == null ? undefined : ((value['accessControls'] as Array<any>).map(AdgangAccessControlToJSON)),
    };
}

